import * as React from 'react';
import * as Yup from 'yup';

import { Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Formik, FormikActions, FormikProps } from 'formik';
import { mergeFields, processApiError, toFormGroupStyle } from 'common/utils/form';
import { FormInput } from 'common/components/form/FormInput';

import { FormErrorFeedback } from 'common/components/form/FormErrorFeedback';
import { TAG_TYPES } from './SummitRegistrants';
import { SummitRegistrant } from 'common/api/models/SummitRegistrant';
import { SummitRegistrantApi } from 'common/api/resources/SummitRegistrantApi';
// import { toSlug } from 'common/utils/utils';
import { Analytics } from 'common/utils/Analytics';
// import { FormInput } from 'common/components/form/FormInput';
// import { MediaUpload } from 'common/components/form/MediaUpload';
import { Feature } from 'common/features/Feature';
import { AppState } from 'common/models/AppState';
import { canViewBadges } from 'common/features/canViewBadges';

interface SummitRegistrantsDialogProps {
  summitRegistrant?: SummitRegistrant;
  appState: AppState;
  onSave: (saved: string) => void;
  onCancel: () => void;
}

class SummitRegistrantsFormValues {
  email: string = '';
  firstName: string = '';
  lastName: string = '';
  thirdParty: string = '';
  isMember: boolean = false;
  isMemberText: string = 'false';
  summitId: string = '';
  //  shortName: string = '';
  //  imagePath: string = '';
  //  description: string = '';
  //  type: string = '';
}

export class SummitRegistrantsDialog extends React.Component<SummitRegistrantsDialogProps> {
  summitRegistrantTypes = canViewBadges(Feature.badges, this.props.appState.config, this.props.appState.user)
    ? [...TAG_TYPES, { label: 'Badge', value: 'BADGE' }]
    : TAG_TYPES;

  initialValues() {
    if (this.props.summitRegistrant) {
      this.props.summitRegistrant.isMemberText =
        this.props.summitRegistrant && this.props.summitRegistrant.isMember ? 'true' : 'false';
    }

    return mergeFields(new SummitRegistrantsFormValues(), this.props.summitRegistrant);
  }

  handleSubmit = (values: SummitRegistrantsFormValues, actions: FormikActions<SummitRegistrantsFormValues>) => {
    values.isMember = values && values.isMemberText === 'true' ? true : false;
    if (values.isMemberText) {
      delete values.isMemberText;
    }

    const summitRegistrantData = {
      ...values,
      //      imagePath: values.imagePath === '' ? '' : values.imagePath,
      //      type: SummitRegistrant.Type[values.type],
    };
    const call =
      this.props.summitRegistrant && this.props.summitRegistrant.id
        ? SummitRegistrantApi.updateSummitRegistrant(this.props.summitRegistrant.id, summitRegistrantData)
        : SummitRegistrantApi.createSummitRegistrant(summitRegistrantData);
    const analyticsEvent =
      this.props.summitRegistrant && this.props.summitRegistrant.id
        ? Analytics.summitRegistrant.update
        : Analytics.summitRegistrant.create;
    call.then(
      res => {
        this.props.onSave(
          this.props.summitRegistrant && this.props.summitRegistrant.id
            ? this.props.summitRegistrant.id
            : (res as any).id
        );
        analyticsEvent();
        actions.setSubmitting(false);
        actions.setStatus(undefined);
      },
      err => {
        processApiError<SummitRegistrantsDialogProps, SummitRegistrantsFormValues>(err, actions);
      }
    );
  };

  render() {
    const title =
      this.props.summitRegistrant && this.props.summitRegistrant.id ? 'Edit SummitRegistrant' : 'Add SummitRegistrant';

    return (
      <Modal size="md" isOpen={!!this.props.summitRegistrant} toggle={this.props.onCancel} keyboard={true}>
        <Formik
          initialValues={this.initialValues()}
          validationSchema={Yup.object().shape({
            email: Yup.string().required('Required'),
            //            type: Yup.string().required('Required'),
            //            description: Yup.string()
            //              .min(10, 'Please describe this summitRegistrant so people in 6 months will know what it is.')
            //              .required('Required'),
          })}
          onSubmit={this.handleSubmit}
          render={(form: FormikProps<SummitRegistrantsFormValues>) => (
            <form onSubmit={form.handleSubmit} noValidate={true}>
              <ModalHeader toggle={this.props.onCancel}>{title}</ModalHeader>
              <ModalBody>
                {this.props.summitRegistrant && this.props.summitRegistrant.id && (
                  <div className="mb-3">Edit Email Address for Summit Registrant</div>
                )}
                <FormGroup color={toFormGroupStyle('email', form)}>
                  <Label for="email">Email</Label>
                  <Input
                    id="email"
                    value={form.values.email}
                    onChange={form.handleChange}
                    onBlur={form.handleBlur}
                    spellCheck={false}
                    autoComplete="off"
                  />
                  <FormErrorFeedback field="email" form={form} />
                  <Label for="firstName">First Name</Label>
                  <Input
                    id="firstName"
                    value={form.values.firstName}
                    onChange={form.handleChange}
                    onBlur={form.handleBlur}
                    spellCheck={false}
                    autoComplete="off"
                  />
                  <Label for="lastName">Last Name</Label>
                  <Input
                    id="lastName"
                    value={form.values.lastName}
                    onChange={form.handleChange}
                    onBlur={form.handleBlur}
                    spellCheck={false}
                    autoComplete="off"
                  />
                  <Label for="thirdParty">Third Party</Label>
                  <Input
                    id="thirdParty"
                    value={form.values.thirdParty}
                    onChange={form.handleChange}
                    onBlur={form.handleBlur}
                    spellCheck={false}
                    autoComplete="off"
                  />
                  <FormInput tag="select" name="isMemberText" id="isMemberText" label="Is Member?">
                    <option value="false">No</option>
                    <option value="true" selected={this.props.summitRegistrant && this.props.summitRegistrant.isMember}>
                      Yes
                    </option>
                  </FormInput>
                  <Label for="summitId">Summit ID</Label>
                  <Input
                    id="summitId"
                    value={form.values.summitId}
                    onChange={form.handleChange}
                    onBlur={form.handleBlur}
                    spellCheck={false}
                    autoComplete="off"
                  />
                </FormGroup>
                {form.status && <div className="alert alert-danger">{form.status}</div>}
              </ModalBody>
              <ModalFooter>
                <div>
                  <Button color="secondary" onClick={this.props.onCancel}>
                    Cancel
                  </Button>{' '}
                  <Button color="primary" type="submit">
                    Save
                  </Button>
                </div>
              </ModalFooter>
            </form>
          )}
        />
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/SummitRegistrants/SummitRegistrantDialog.tsx